import React, { useState, useEffect } from 'react';
import channelService, { Channel } from '../services/channelService';

const TopChannels: React.FC = () => {
    const [channels, setChannels] = useState<Channel[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadTopChannels();
    }, []);

    const loadTopChannels = async () => {
        setLoading(true);
        setError('');
        try {
            const topChannels = await channelService.getTopChannels(10);
            setChannels(topChannels);
        } catch (err) {
            console.error('Failed to load top channels:', err);
            setError('Failed to load top channels');
        } finally {
            setLoading(false);
        }
    };

    const getPlatformIcon = (platform: 'twitch' | 'youtube') => {
        return platform === 'twitch' ? '🎮' : '📺';
    };

    const getPlatformColor = (platform: 'twitch' | 'youtube') => {
        return platform === 'twitch' ? '#9146ff' : '#ff0000';
    };

    if (loading) {
        return (
            <div className="top-channels-section">
                <h3>🔥 Top 10 Monitored Channels</h3>
                <div className="loading">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="top-channels-section">
                <h3>🔥 Top 10 Monitored Channels</h3>
                <div className="error-message">{error}</div>
            </div>
        );
    }

    if (channels.length === 0) {
        return (
            <div className="top-channels-section">
                <h3>🔥 Top 10 Monitored Channels</h3>
                <p style={{ color: '#666', fontSize: 14 }}>No channels being monitored yet.</p>
            </div>
        );
    }

    return (
        <div className="top-channels-section">
            <h3>🔥 Top 10 Monitored Channels</h3>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 16 }}>
                Most popular channels across all users
            </p>

            <div className="top-channels-list">
                {channels.map((channel, index) => (
                    <div key={channel.id} className="top-channel-item">
                        <div className="channel-info">
                            <div className="channel-header">
                                {channel.profilePicture && (
                                    <img
                                        src={channel.profilePicture}
                                        alt={channel.channelName || channel.channel_id}
                                        style={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                )}
                                <span className="channel-id">#{index + 1} - {channel.channelName || channel.channel_id}</span>
                            </div>
                            <div className="channel-stats">
                                <span className="notification-count">
                                    {channel.notifications_count} {channel.notifications_count === 1 ? 'user' : 'users'}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopChannels;
